if (!customElements.get('bmf-navigation')) {
  customElements.define('bmf-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.items = [...this.querySelectorAll('details')];
      this.items.forEach(item => {
        const trigger = item.querySelector('summary');
        trigger.setAttribute('aria-expanded', String(item.open));
        item.addEventListener('toggle', () => {
          trigger.setAttribute('aria-expanded', String(item.open));
          if (item.open) this.items.forEach(other => { if (other !== item) other.open = false; });
        }, options);
      });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.items.find(item => item.open);
        if (open) { event.preventDefault(); event.stopPropagation(); open.open = false; open.querySelector('summary').focus(); }
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
    }
    close() { this.items.forEach(item => { item.open = false; }); }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
